<template>
  <ul class="mb-2">
    <li class="menu-item">
      <div>
        <span class="adp-p adp-tree mt-0" :class="{'adp-p__grey': node.is_hidden}">
          <img src="/images/eye_disabled.svg" alt="" v-if="node.is_hidden">
          {{ node.title }}
        </span>
        <span class="tree-icon" @click="toggle" v-if="node.children && Object.keys(node.children).length">
          <i class="d-flex" v-if="opened"><img src="/images/black-minus.svg"></i>
          <i class="d-flex" v-if="!opened"><img src="/images/black-plus.svg"></i>
        </span>
        <img class="adp-competence-kebab mt-0" @click.stop="$emit('open-cm', $event, node, path)" src="/images/vertical_dots.svg">
      </div>
    </li>
    <li v-if="node.children" v-show="opened">
      <competencies-tree
                      class="menu-list" 
                      v-if="node.children"
                      v-for="item, index in node.children"
                      v-show="!(isParentHidden || (!!item.is_hidden && isHideToggleActive))"
                      :key="item.id"
                      :node="item"
                      :path="[...path, index]"
                      :isHideToggleActive="isHideToggleActive"
                      :isParentHidden="isParentHidden || (!!item.is_hidden && isHideToggleActive)"
                      v-on:open-cm="(event, node, path) => $emit('open-cm', event, node, path)">
      </competencies-tree>
    </li>
  </ul>
</template>

<script>
  import CompetenciesTree from "./CompetenciesTree";

  export default {
    name: 'competencies-tree',

    props: {
      node: Object,
      path: Array,
      isHideToggleActive: Boolean,
      isParentHidden: Boolean,
    },

    components: {
      CompetenciesTree
    },

    data: () => ({
      opened: false,
    }),

    methods: {
      toggle() {
        this.opened = !this.opened;
      },
    }
  }
</script>

<style scoped>
  ul:first-child {
    margin-top: 0.5rem;
  }

  .adp-competence-kebab {
    padding: 2px 12px;
    cursor: pointer;
    display: inline;
    visibility: hidden;
    margin-top: -4px;
  }

  .adp-tree {
    float: left;
    margin-top: 5px;
  }

  .tree-icon {
    width: 10px;
    height: 10px;
    margin-left: 8px;
    cursor: pointer;
    margin-left: 22px;
    margin-right: 5px;
  }

  .tree-icon img {
    width: 10px;
    height: 10px;
  }

  .menu-list {
    list-style: none;
    padding-left: 20px;
  }

  .menu-item {
    display: table-cell;
    vertical-align: middle;
    justify-content: space-between;
    align-items: baseline;
  }

  .menu-item div {
    display: flex;
    align-items: center
  }

  .menu-item:hover .adp-competence-kebab {
    visibility: visible;
  }

  @media (min-width: 576px) {
    .menu-item {
      justify-content: start;
    }
  }
</style>
